import { Box, SearchInput } from '@modusign/design-system';
import { ChangeEvent, FocusEvent, FormEvent, useCallback, useEffect, useState } from 'react';

interface SearchAreaProps {
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
  onSubmit: (value: string) => void;
}

const defaultProps = {
  placeholder: null,
  value: null,
  onChange(_value: string) {},
  onSubmit(_value: string) {},
};

function SearchArea({ placeholder, value: valueProps, onChange, onSubmit }: SearchAreaProps) {
  const [value, setValue] = useState(valueProps);

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      setValue(event.target.value);
    },
    [setValue]
  );

  const handleReset = () => {
    setValue('');
    onChange('');
    onSubmit('');
  };

  const handleBlur = useCallback(
    (event: FocusEvent<HTMLInputElement>) => {
      onChange(event.target.value);
    },
    [onChange]
  );

  const handleClick = () => {
    const searchKeyword = value?.trim() ?? '';

    onChange(searchKeyword);
    onSubmit(searchKeyword);
  };

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const searchKeyword = value?.trim() ?? '';

    onChange(searchKeyword);
    onSubmit(searchKeyword);
  };

  useEffect(() => {
    if (!valueProps) {
      setValue('');
    }
  }, [valueProps]);

  return (
    <Box as="form" onSubmit={handleSubmit}>
      <SearchInput
        borderBottomLeftRadius={0}
        borderTopLeftRadius={0}
        placeholder={placeholder ?? undefined}
        style={value ? {} : { paddingRight: '36px' }}
        type="text"
        value={value ?? undefined}
        onBlur={handleBlur}
        onChange={handleChange}
        onClick={handleClick}
        onReset={handleReset}
      />
    </Box>
  );
}

SearchArea.defaultProps = defaultProps;

export default SearchArea;
